export var getTitle = function (props) {
    if (typeof props.title === 'function') {
        return props.title(props.item, props.index);
    }
    if (props.title === null)
        return null;
    return "".concat(props.title || props.defaultCardTitle, " ").concat(props.index + 1);
};
